module.exports = __webpack_public_path__ + "static/img/js_logo.5d78702.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/js_logo.png
// module id = qzkX
// module chunks = 159